import { Typography } from '@material-tailwind/react';
import React from 'react';

const TdCompras = ({ cssTd, children }) => {
  return (
    <td className={`p-2 border-b border-blue-gray-50 ${cssTd}`}>
      <Typography color="black" className="font-normal">
        {children}
      </Typography>
    </td>
  );
};

export default TdCompras;
